// Zinsdelen voor de samenvatting van een herhaling (Arabisch). Zelfde vorm als recurrenceApp.nl.ts.
// Rangtelwoorden mannelijk, na "يوم" ("يوم الجمعة الأخير").
export const appRecurrenceAr = {
    once: 'مرة واحدة',
    everyDay: 'كل يوم',
    everyWorkday: 'كل يوم عمل',
    everyWeek: 'كل أسبوع',
    everyMonth: 'كل شهر',
    everyYear: 'كل سنة',
    everyWeekdays: 'كل يوم {days}',
    otherDay: 'يومًا بعد يوم',
    otherWeek: 'كل أسبوعين',
    otherMonth: 'كل شهرين',
    otherYear: 'كل سنتين',
    nDays: {
        zero: 'كل {count} يوم',
        one: 'كل يوم',
        two: 'كل يومين',
        few: 'كل {count} أيام',
        many: 'كل {count} يومًا',
        other: 'كل {count} يوم',
    },
    nWeeks: {
        zero: 'كل {count} أسبوع',
        one: 'كل أسبوع',
        two: 'كل أسبوعين',
        few: 'كل {count} أسابيع',
        many: 'كل {count} أسبوعًا',
        other: 'كل {count} أسبوع',
    },
    nMonths: {
        zero: 'كل {count} شهر',
        one: 'كل شهر',
        two: 'كل شهرين',
        few: 'كل {count} أشهر',
        many: 'كل {count} شهرًا',
        other: 'كل {count} شهر',
    },
    nYears: {
        zero: 'كل {count} سنة',
        one: 'كل سنة',
        two: 'كل سنتين',
        few: 'كل {count} سنوات',
        many: 'كل {count} سنة',
        other: 'كل {count} سنة',
    },
    dailyOnlyOn: '{period}، فقط يوم {days}',
    weeklyOn: '{period} يوم {days}',
    weeklyAllDays: '{period} في كل الأيام',
    weeklyWorkdays: '{period} في أيام العمل',
    monthlyOrdinal: 'كل شهر في {ordinals}',
    monthlyOrdinalPeriod: '{period} في {ordinals}',
    monthlyOn: '{period} في {days}',
    ifWeekday: '{text} إذا كان يوم {days}',
    monthDay: 'اليوم {day}',
    lastDay: 'اليوم الأخير',
    nthLastDay: 'اليوم {ordinal}',
    yearlyOrdinal: '{period} في {ordinals} من {months}',
    yearlyOn: '{period} في {date}',
    yearlyDays: '{period} في {days} من {months}',
    dayMonth: '{day} {month}',
    ordinalWeekday: 'يوم {weekday} {ordinals}',
    anyWeekday: 'كل يوم {weekday}',
    ord1: 'الأول',
    ord2: 'الثاني',
    ord3: 'الثالث',
    ord4: 'الرابع',
    ord5: 'الخامس',
    ordLast: 'الأخير',
    ordLast2: 'قبل الأخير',
    ordLast3: 'الثالث من الآخر',
    ordLast4: 'الرابع من الآخر',
    ordLast5: 'الخامس من الآخر',
    ordN: 'رقم {n}',
    evenWeeks: '{text} في الأسابيع الزوجية',
    oddWeeks: '{text} في الأسابيع الفردية',
    at: '{text} الساعة {time}',
    fromTo: '{text} من {start} إلى {end}',
    times: {
        zero: '{text}، {count} مرة',
        one: '{text}، مرة واحدة',
        two: '{text}، مرتين',
        few: '{text}، {count} مرات',
        many: '{text}، {count} مرة',
        other: '{text}، {count} مرة',
    },
    until: '{text}، حتى {date}',
    listAnd: '{a} و{b}',
    listSep: '، ',
};
//# sourceMappingURL=recurrenceApp.ar.js.map